import { F0Box, F0Button } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import SalaryIndicator from 'modules/job_catalog/benchmark/components/SalaryIndicator'
import { MarketPosition } from 'modules/job_catalog/benchmark/types'

const getPositionLabel = (position: MarketPosition): string => {
  switch (position) {
    case 'below':
      return i18n.t('job_catalog.benchmark.market_position.below')
    case 'at_market':
      return i18n.t('job_catalog.benchmark.market_position.at_market')
    case 'above':
      return i18n.t('job_catalog.benchmark.market_position.above')
    default:
      return i18n.t('job_catalog.benchmark.market_position.unknown')
  }
}

const getBadgeLabel = (position: MarketPosition, delta?: number | null): string => {
  if (delta != null && position === 'below') {
    return i18n.t('job_catalog.benchmark.market_position.below_delta', { delta })
  }
  if (delta != null && position === 'above') {
    return i18n.t('job_catalog.benchmark.market_position.above_delta', { delta })
  }
  return getPositionLabel(position)
}

const getBadgeClassName = (position: MarketPosition): string => {
  switch (position) {
    case 'below':
      return 'text-f1-foreground-warning'
    case 'at_market':
      return 'text-f1-foreground-positive'
    case 'above':
      return 'text-f1-foreground-info'
    default:
      return 'text-f1-foreground-secondary'
  }
}

interface Props {
  position: MarketPosition
  marketDelta?: number | null
  title?: string
  onClose: () => void
}

const SalaryPopoverHeader = ({ position, marketDelta, title, onClose }: Props) => {
  return (
    // eslint-disable-next-line factorial/no-raw-html -- Exact pixel sizing not available via F0Box tokens
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: 64,
        paddingLeft: 12,
        paddingRight: 6,
        paddingTop: 6,
        boxSizing: 'border-box',
      }}
    >
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
        <SalaryIndicator position={position} size="sm" colorMode="modal" />
        {/* eslint-disable-next-line factorial/no-raw-html -- F0Text style prop is blocked; 14px/500 not available as a variant */}
        <span className={getBadgeClassName(position)} style={{ fontWeight: 500, fontSize: 14 }}>
          {title ?? getBadgeLabel(position, marketDelta)}
        </span>
      </F0Box>

      <F0Button
        label={i18n.t('common.close')}
        variant="outline"
        size="sm"
        icon={Cross}
        hideLabel
        round
        onClick={onClose}
      />
    </div>
  )
}

export default SalaryPopoverHeader
